<template>
    <f7-page
        :page-content="false"
        name="Login"
        class="onboardingBg"
        navbar-hidden
        no-navbar
    >
        <div class="bg-wrapper">
            <div class="parallax-bg" />
            <div
                v-if="noKeyboard"
                class="parallax-bg-3"
            />
            <div
                v-if="noKeyboard"
                class="parallax-bg-2"
            />
            <div style="max-width: 400px; margin: 0 auto">
                <p class="longScreenFix" />
                <h1 style="margin: 80px 0 0 14px; text-align: left; font-size: 26px; color: black">Log in to
                    <svg
                        width="116"
                        viewBox="0 0 432 142"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                        <path
                            fill="black"
                            d="M125.07,55.31c-1.45,3.77-2.36,6.07-3.19,6-.33,0-1-.69-1.11-1.53-6-19.45-22.11-25.6-39-26.14-30.19-1-48,20.25-48.89,49.77-.91,28.87,14.24,53.76,45.43,54.74,22.06.7,36.48-9,42.66-20.41.77-1,1.93-3.12,2.83-4.69a1.19,1.19,0,0,1,2.12.12c1.5,3.45,4.5,9.33,5.65,11.57a1.2,1.2,0,0,1-.35,1.51l-4.48,3.3c-13.91,9.36-31,13.3-47.73,12.77-32.18-1-65.09-21.14-64-57C16.2,48.06,47.7,28.46,82,29.54c17.76.56,33.28,5.86,45.8,15.7a1.23,1.23,0,0,1,.38,1.37Z"
                        />
                        <path
                            fill="black"
                            d="M180.77,51.13c25.07,0,49.13,18.25,49.13,45.64s-24.06,45.64-49.13,45.64-49.12-18.26-49.12-45.64S155.71,51.13,180.77,51.13Zm0,87.13c24.57,0,33.37-18.92,33.2-41.49.17-22.57-8.63-41.5-33.2-41.5s-33.36,18.93-33.19,41.5C147.41,119.34,156.21,138.26,180.77,138.26Z"
                        />
                        <path
                            fill="black"
                            d="M279.74,67.72c-2-1.66-4.48-4.31-9-4.31-13.94,0-18.42,16.76-18.42,43v10.13c0,12.28,1.49,20.08,8.13,20.91,1.82.17,2.82.83,2.82,2,0,.83-.5.83-1.33.83-2.82,0-9-.33-14.77-.33s-12,.33-14.77.33c-.83,0-2-.33-2-.83,0-.66,1.16-1.49,2.82-2.15,5.31-2.66,6.8-8.47,6.8-23.74V65.4c0-3.32-2.82-5.48-5.64-6.47-1.33-.34-2.49-1-2.49-1.33s1-.67,2.16-1L251.36,52V75.19h.33c7.47-16.26,17.26-24.06,33.69-24.06Z"
                        />
                        <path
                            fill="black"
                            d="M370.69,115c0,10.46,1.33,21.25,5.81,22.74.83.34,1.33.83,1.33,1.33a1.35,1.35,0,0,1-1.5,1.16c-.66,0-4.65-.33-6.47-.33-2.16,0-4.32.33-6.14.33-1.33,0-2-.83-2-1.32,0-4.15-2.33-11-2.82-15.61h-.34c-7.13,14.28-19.75,19.09-35,19.09-16.1,0-35.35-8.46-35.35-26.56,0-25.39,37.84-29.21,56.6-29.21h12.61c0-19.42-5.48-31.37-26.56-31.37-11.61,0-30.37,6.31-31.86,19.42,0,.5-.33.67-.83.67-.33,0-.5,0-.67-.5L293,59.09a96.52,96.52,0,0,1,37.35-8c30.2,0,40.33,13.11,40.33,32.36ZM345.13,90.79c-17.59,0-41,3.32-41,25.4,0,14.6,11.29,22.07,24.73,22.07,24.9,0,28.55-19.92,28.55-40.16V90.79Z"
                        />
                        <path
                            fill="black"
                            d="M407.38,115.85c0,9.63.83,19.42,6.14,21.58,1.66.67,3.49,1.33,3.49,2.16,0,.5-2,.66-2.82.66-2,0-8.14-.33-12.95-.33s-10.95.33-13.77.33c-3,0-3.66-.16-3.66-.66,0-.83,2.16-1.49,4.49-2.49,6-2.66,6.8-17.1,6.8-34.36V43.82c0-12.45-1.33-16.1-5.81-17.76-1.16-.33-1.66-.66-1.66-1,0-.5.83-.83,1.5-1l18.25-4.48Z"
                        />

                    </svg>
                </h1>

                <f7-list
                    no-hairlines
                    form
                    style="max-width: 400px; margin: 20px auto 40px;"
                >
                    <template v-if="loginMode === 'email'">
                        <f7-list-input
                            autocomplete="email"
                            label="Your email"
                            type="email"
                            placeholder="your@email.com"
                            @input="email=($event.target.value || '')"
                            @change="email=($event.target.value || ''); emailChange();"
                        >
                            <f7-link
                                slot="label"
                                style="float: right; color: #777"
                                @click="loginMode = 'phone'; phone = ''; email = ''; switchMode('phone')"
                            >use phone</f7-link>
                        </f7-list-input>
                        <!-- Autocompleters and password gen do not register on @input -->

                        <f7-list-input
                            autocomplete="current-password"
                            label="Your password"
                            type="password"
                            placeholder="****"
                            @input="password=($event.target.value || '')"
                            @change="password=($event.target.value || '')"
                            @keyup.enter="login"
                        >
                            <f7-link
                                slot="label"
                                style="float: right; color: #777"
                                @click="recover"
                            >Recover Password</f7-link>
                        </f7-list-input>
                    </template>
                    <template v-else>
                        <f7-list-input
                            :value="phone"
                            autocomplete="phone"
                            label="Enter your phone number"
                            type="tel"
                            name="phone"
                            placeholder="+1 (917) 123 4839"
                            @input="phone=($event.target.value || '')"
                            @change="phone=($event.target.value || ''); phoneChange();"
                            @keyup.enter="loginPhone"
                        >
                            <f7-link
                                slot="label"
                                style="float: right; color: #777"
                                @click="loginMode = 'email'; phone = ''; email = ''; switchMode('email')"
                            >use email</f7-link>
                        </f7-list-input>

                    </template>
                    <div id="recaptcha-container" />
                </f7-list>
                <f7-block style="margin-top: -20px; margin-bottom: 10px; border: 0px solid white">

                    <f7-row style="margin: 0 auto; max-width: 380px;">
                        <f7-col width="33">
                            <f7-button
                                style="width: 120px"
                                large
                                round
                                fill
                                color="red"
                                @click="loginMode === 'email' ? login() : loginPhone();"
                            >LOGIN</f7-button>
                        </f7-col>
                        <f7-col width="66">
                            <f7-button
                                class="minorActions"
                                style="float: right; line-height:60px; height: 60px; letter-spacing: -.3px"
                                href="/register"
                            >Need an account?</f7-button>
                        </f7-col>
                    </f7-row>

                    <f7-row v-if="showCmsButton">
                        <f7-col width="100">
                            <f7-button
                                style="width: 100%"
                                small
                                round
                                fill
                                color="blue"
                                @click="redirectToCMS();"
                            >CMS</f7-button>
                        </f7-col>
                    </f7-row>

                </f7-block>
            </div>
        </div>
    </f7-page>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import validator from 'validator';

export default {
    data () {
        return {
            show: false,
            email: '',
            password: '',
            company: false,
            phone: '',
            appVerifier: '',
            processing: false,
            noKeyboard: true,
            codePrompt: null,
            showCmsButton: false,
        };
    },
    store: ['myDevice', 'user', 'api', 'text', 'loginMode'],
    mounted: function () {
        this.initReCaptcha();
        window.app.$events.on('keyboard-open', () => {
            this.noKeyboard = false;
        });
        window.app.$events.on('keyboard-close', () => {
            this.noKeyboard = true;
        });
    },
    methods: {
        emailChange: function () {
            this.email = this.email.toLowerCase();
        },
        phoneChange: function () {
            if (this.phone[0] === '0' && this.phone[1] === '0') {
                this.phone = this.phone.replace('00', '+');
            }
            // if (this.phone[0] === '0') {
            //     if (this.phone[1] === '0') this.phone = this.phone.substr(1);
            //     if (this.phone[0] === '0') {
            //         this.phone = `+${this.phone.substr(1)}`;
            //     }
            // }
            // // we let the use put + himself
            // // when the user does that the likelihood that he put the area code right after is high
            // this.phone = `+${this.phone.replace(/\D/g, '')}`;
        },
        switchMode: function (mode) {
            this.$events.fire('trackEvent', 'authentication_mode_change', 'auth', 0, `change to ${mode}`);
        },
        initReCaptcha: function () {
            setTimeout(() => {
                // firebase.auth().settings.appVerificationDisabledForTesting = true;
                window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
                    'size': 'invisible',
                    'callback': function () {
                        // reCAPTCHA solved, allow signInWithPhoneNumber.
                        // ...
                    },
                    'expired-callback': function () {
                        // Response expired. Ask user to solve reCAPTCHA again.
                        // ...
                    }
                });
                //
                this.appVerifier = window.recaptchaVerifier
            }, 1000);
        },
        getPhoneWithAreaCode: async function (phone) {
            // this is not ideal but this is a quick fix
            // Ideally let's move the whole firebase logic to the backend
            // And write the business logic of the phone numbers there into one call
            let response;
            try {
                // Get the phone with a proper area code
                response = (await this.$http.get(`${this.api}/phone/${phone}`)).body.phone;
            } catch (error) {
                response = phone;
                console.error("An error occurred while trying to get the phone number", error);
            }

            return response;
        },
        login: async function () {
            if (this.processing) return;

            if (!validator.isEmail(this.email)) {
                // the backend als use validator
                // we double check here to save the trip to the backend
                return f7.dialog.alert('Invalid email address', 'Try again');
            } else if (!validator.isLength(this.password, { min: 6, max: undefined })) {
                return f7.dialog.alert('Password must be at least 6 characters.', 'Try again');
            }


            this.processing = true;
            Vue.http.headers.common.uuid = localStore.getItem('uuid');
            f7.preloader.show();
            this.$events.on('jwt-set', () => {
                this.$events.off('jwt-set');
                this.$events.fire('user-get', 'login', true);
            });


            firebase
                .auth()
                .signInWithEmailAndPassword(this.email, this.password)
                .then(
                    user => {
                        console.log('Login ok', user);

                        firebase.auth().currentUser.getIdTokenResult().then((idTokenResult) => {
                            this.showCmsButton = idTokenResult.claims.isAdmin && idTokenResult.claims.email_verified;
                        });

                        this.processing = false;
                        f7.preloader.hide();
                    },
                    err => {
                        this.$events.off('jwt-set');
                        f7.preloader.hide();
                        /// no number for this one as happens often
                        f7.dialog.alert(err.message, 'Authentication Error');
                        this.processing = false;
                    }
                );
        },
        redirectToCMS: function () {
            window.location.href = '/admin/start';
        },
        loginPhone: async function () {
            if (this.processing) return;
            if (this.phone.length < 5) return f7.dialog.alert('Invalid phone number');
            this.processing = true;
            Vue.http.headers.common.uuid = localStore.getItem('uuid');
            if (!this.phone.includes('+')) {
                // Get from free twilio API
                this.phone = await this.getPhoneWithAreaCode(this.phone.replace(/\D/g, ''));
            }
            this.phone = `+${this.phone.replace(/\D/g, '')}`;
            f7.preloader.show();
            this.$events.on('jwt-set', () => {
                this.$events.off('jwt-set');
                this.$events.fire('user-get', 'login', true);
                this.codePrompt.close() // programmatically close the SMS code prompt if auto-verified
            });
            if (pgap) {
                setTimeout(() => { // prevent double tap
                    f7.preloader.hide();
                    this.processing = false;
                }, 400);
                cordova.plugins.firebase.auth.verifyPhoneNumber(this.phone, 30000).then((verificationId) => {
                    // pass verificationId to signInWithVerificationId
                    window.confirmationResult = verificationId;
                    this.codePrompt = f7.dialog.prompt('Enter SMS code', this.phoneConfirm);
                    setTimeout(() => {
                        $$('.dialog-input').attr('inputmode', "numeric");
                        $$('.dialog-input').attr('pattern', "[0-9]*");
                        $$('.dialog-input').attr('autocomplete', "one-time-code");
                    }, 100);
                });
            } else {
                if (this.phone[0] === '0') {
                    if (this.phone[1] === '0') this.phone = this.phone.substr(1);
                    if (this.phone[0] === '0') this.phone[0] = '1'; // cheap US hack
                }
                this.phone = `+${this.phone.replace(/\D/g, '')}`;
                console.log(this.phone, window.recaptchaVerifier);
                firebase
                    .auth()
                    .signInWithPhoneNumber(this.phone, window.recaptchaVerifier)
                    .then(
                        confirmationResult => {
                            window.confirmationResult = confirmationResult;
                            f7.dialog.prompt('Enter SMS code', this.phoneConfirm);
                            setTimeout(() => {
                                this.processing = false;
                                $$('.dialog-input').attr('inputmode', "numeric");
                                $$('.dialog-input').attr('pattern', "[0-9]*");
                                $$('.dialog-input').attr('autocomplete', "one-time-code");
                            }, 100);
                            f7.preloader.hide();
                        },
                        err => {
                            this.$events.off('jwt-set');
                            f7.preloader.hide();
                            this.processing = false;
                            /// no number for this one as happens often
                            f7.dialog.alert(err.message, 'Authentication Error');
                        }
                    );
            }
        },
        phoneConfirm: function (otp) {
            if (this.phone.length < 8 || otp.length != 6) {
                f7.dialog.alert('Invalid Phone Number/code format !');
            } else {
                if (pgap) {
                    cordova.plugins.firebase.auth.signInWithVerificationId(window.confirmationResult, otp);
                } else {
                    window.confirmationResult.confirm(otp).then((result) => {
                        // User signed in successfully.
                        var user = result.user;
                        console.log('Login ok', user);
                        // ...
                        //route to set password !
                        // vm.$router.push({path:'/setPassword'})
                    }).catch((error) => {
                        console.error(error);
                        f7.dialog.alert('Invalid code', 'Authentication Error');
                        // User couldn't sign in (bad verification code?)
                        // ...
                    });
                }
            }
        },
        recover: function () {
            var auth = firebase.auth();
            f7.dialog.prompt('Enter your email', email => {
                auth.sendPasswordResetEmail(email)
                    .then(() => {
                        // Email sent.
                    })
                    .catch(error => {
                        // An error happened.
                        f7.dialog.alert(error);
                    });
            });
        }
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
@media screen and (min-height: 1000px) {
    .longScreenFix {
        margin-top: 20vh;
    }
}
.minorActions {
    font-family: AndesBook;
    text-transform: uppercase;
    font-size: 16px !important;
    color: #000;
    letter-spacing: 0px;
}
.ansButton {
    background: @background;
}
.item-input-wrap {
    border-bottom: 1px solid #ddd;
}
.item-input-focused .item-input-wrap {
    border-bottom: 1px solid @green;
}
.absBottom {
    text-align: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    margin: 0;
    a {
        max-width: 300px;
        cursor: pointer;
        margin: 0px auto;
        line-height: 55px;
        padding: 0 15px;
        height: 55px;
        font-size: 16px;
        color: #777777;
        // &.active-state {
        // }
        &.nextBtn {
            color: @coral;
            font-size: 18px;
            font-weight: bold;
            position: absolute;
            right: 30px;
            bottom: 76px;
            background: white;
            border-radius: 6px;
        }
    }
}

.vcenter {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.ios.device-iphone-x .vcenter {
    margin-top: -50px;
}
.bg-wrapper {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
}
.parallax-bg {
    position: absolute;
    left: 40vw;
    top: 0;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_top.png) top right no-repeat;
    background-size: 3670.5px 171.5px;
    height: 171.5px;
    width: 3670.5px;
}
.parallax-bg-2 {
    position: absolute;
    left: calc(~'-3000px' + 50vw);
    bottom: 0px;
    background: url(../../img/1.2.0/onboarding_bottom.png) bottom left no-repeat;
    background-size: 5954.5px 804px;
    height: 804px;
    width: 5954.5px;
}
.parallax-bg-3 {
    position: absolute;
    left: calc(~'-1200px' + 50vw);
    bottom: 0px;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_bottom2.png) bottom left
        no-repeat;
    background-size: 1476px 535.5px;
    height: 535.5px;
    width: 1476px;
}
</style>
